import { Component, OnInit } from '@angular/core';
import { Usuario } from '../model/usuario';
import { LoginService } from './login.service';
import { Router } from '@angular/router';

import { NotificationService } from "./../notification/notification.service";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  usuario: any;

  constructor(private loginService: LoginService, private router: Router,
    private notificationService: NotificationService) {
    this.usuario = new Usuario();
    if (new Date().getHours() < 12) {
      this.notificationService.info(
        "Bom dia! Bem vindo(a) ao Gerenciador do Portal CMCTI!"
      );
    } else {
      this.notificationService.info(
        "Boa tarde! Bem vindo(a) ao Gerenciador do Portal CMCTI!"
      );
    }
  }

  ngOnInit() {
    
  }

  onSubmit(): void {
    this.loginService.login(this.usuario)
      .subscribe(
        res => {
          if (res != null) {
            sessionStorage.setItem("usuario", JSON.stringify(res));
            this.router.navigateByUrl("/gerenciador/inicio");
          }
        },
        error => {
          this.notificationService.error(
            "Opa! O usuário e/ou senha está(ão) errado(s), verifique e tente novamente."
          );
        });
  }

}


// WEBPACK FOOTER //
// ./src/app/login/login.component.ts